<template>
  <v-hover v-slot="{ isHovering, props: hoverProps }">
    <div v-bind="hoverProps">
      <v-row
        :class="{ 'my-1': showDivider, 'mt-1': !showDivider }"
        class="mx-1"
      >
        <v-menu>
          <template #activator="{ props }">
            <v-btn
              :elevation="isHovering || !hasAddedRow ? 5 : 0"
              :color="
                isHovering || !hasAddedRow ? 'grey-darken-3' : 'grey-lighten-2'
              "
              class="ml-n5 mt-n4 test-insert-button"
              width="25px"
              height="25px"
              v-bind="props"
              icon
              size="x-small"
            >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item
              v-for="(option, idx) in insertOptions"
              class="test-insert-option"
              :key="idx"
              @click="$emit('add-row', option)"
            >
              <v-list-item-title>{{ option }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
      <v-divider
        v-if="showDivider"
        :color="isHovering ? 'gray' : 'white'"
        class="mt-n4"
      />
    </div>
  </v-hover>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { RowTypes } from '@oare/types';

export default defineComponent({
  props: {
    hasAddedRow: {
      type: Boolean,
      required: true,
    },
    showDivider: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['add-row'],
  setup() {
    const insertOptions = ref<RowTypes[]>([
      'Line',
      'Broken Line(s)',
      'Ruling(s)',
      'Seal Impression',
      'Broken Area',
      'Uninscribed Line(s)',
    ]);
    return {
      insertOptions,
    };
  },
});
</script>
